'use client';

import React, { useRef } from 'react';
import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import LottieRender from './LottieRender';

const TeamCapabilities = () => {
    const containerRef = useRef<HTMLDivElement>(null);

    return (
        <section ref={containerRef} className="py-24 bg-slate-50 overflow-hidden">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-16">
                    <h2 className="text-4xl font-black text-slate-900 mb-4">
                        Unified <span className="text-indigo-600">Capabilities</span>
                    </h2>
                    <p className="text-slate-600 max-w-2xl mx-auto">
                        A syllabus of excellence. Our team combines diverse skill sets to deliver comprehensive solutions.
                    </p>
                </div>

                <div className="grid lg:grid-cols-2 gap-12 items-center">
                    {/* Visual - Team Work Lottie */}
                    <div className="h-[400px] md:h-[500px] w-full bg-white rounded-3xl shadow-xl overflow-hidden p-8 flex items-center justify-center border border-slate-100">
                        <LottieRender animationPath="/animations/team_v2.json" />
                    </div>

                    {/* Grid of Capabilities */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        {[
                            { title: "Full-Stack Dev", desc: "React, Next.js, Node.js architecture." },
                            { title: "Cloud Infra", desc: "AWS, Scalable serverless systems." },
                            { title: "SEO Strategy", desc: "Technical optimization & visibility." },
                            { title: "UX/UI Design", desc: "Human-centric digital experiences." }
                        ].map((cap, i) => (
                            <div key={i} className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow">
                                <div className="h-10 w-10 bg-indigo-50 rounded-lg flex items-center justify-center mb-4 text-indigo-600 font-bold">
                                    {i + 1}
                                </div>
                                <h3 className="text-lg font-bold text-slate-900 mb-2">{cap.title}</h3>
                                <p className="text-sm text-slate-500">{cap.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TeamCapabilities;
